<template>
	<footer id="piedepagina">
		<VContacto v-model="configuración.contacto"></VContacto>
		<div>
			<ParteTexto v-model="value.texto" class="text-center" style="width: 100%"></ParteTexto>
		</div>
	</footer>
</template>

<script>

import ParteTexto from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Parte/ParteTexto'
import VContacto from '@/components/base/VContacto.vue'

export default {
  name: 'Piedepagina',

	components: {
		ParteTexto,
		VContacto
	},
	
	props: {
		value: {
			type: Object,
			default: function() {
				return { texto: '' }
			}
		},
		configuración: {
			type: Object,
			required: true
		}
	},

};

</script>
